module.exports = __webpack_public_path__ + "static/crab-cakes-red-wine-1e971274b88cf458c5d9d6eed475e123.jpg";